import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.array.filter";
import { useCallback } from 'react';
/**
 * A React custom hook similar to [`useAllCallbacks`](#useallcallbacks), but
 * it'll pass the returned value from a function to the next function.
 */

function usePipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return useCallback(function (arg) {
    var filteredFns = fns.filter(Boolean);
    return filteredFns.reduce(function (acc, curr) {
      return curr(acc);
    }, arg);
  }, fns);
}

export { usePipe };